module.exports = __webpack_public_path__ + "display_mode_tab_vertical.2941380181291e94a76b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/display_mode_tab_vertical.svg
// module id = ./src/assets/img/display_mode_tab_vertical.svg
// module chunks = main